(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pnm-brand-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.pnmBrandHeroReady) return;
  window.pnmBrandHeroReady = true;
  const bikeFilterKeys = ['gff_705339', 'gff_705340', 'gff_705341', 'gff_705342'];
  const selectionKey = 'pnm_selected_bike_v1';
  const decorateLinks = () => {
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (!previewTheme) return;
    document.querySelectorAll('[data-pnm-brand-link]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.origin !== location.origin) return;
      target.searchParams.set('preview_theme_id', previewTheme);
      link.href = target.pathname + target.search;
    });
  };
  const browseBrand = event => {
    const link = event.target.closest('[data-pnm-brand-link]');
    if (!link || event.button > 1 || event.defaultPrevented) return;
    const target = new URL(link.href, location.origin);
    if (target.origin !== location.origin) return;
    [...bikeFilterKeys, selectionKey].forEach(key => {
      try { localStorage.removeItem(key); } catch (error) {}
    });
    window.defaultFilterParams = {};
    const current = new URL(location.href);
    [...bikeFilterKeys, 'gf_852962', 'gf_select-your-model'].forEach(key => current.searchParams.delete(key));
    if (current.href !== location.href) history.replaceState(history.state, '', current.href);
    window.dispatchEvent(new StorageEvent('storage', { key: selectionKey, newValue: null }));
  };
  document.addEventListener('click', browseBrand, true);
  document.addEventListener('auxclick', browseBrand, true);
  document.addEventListener('shopify:section:load', decorateLinks);
  window.addEventListener('pageshow', decorateLinks);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateLinks, { once: true });
  else decorateLinks();
})();

  } catch(e) { console.error(e); }
})();
})();
